<div class="slideout-content">
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0">
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        (click)="toggleSidebar()"
                >
                    ×
                </button>
                <div class="modal-header">
                    <h5 class="modal-title" *ngIf="!data || !data['id']">Add Ticket</h5>
                    <h5 class="modal-title" *ngIf="data && data['id']">Update Ticket</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <form class="form mt-2 shadow-none" novalidate [formGroup]="addSupportForm">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="type">Type</label>
                                        <select class="form-control resize-none" id="type" type="text"
                                                formControlName="type">
                                            <option value="">Select Support Type</option>
                                            <option value="FINANCIAL">Financial</option>
                                            <option value="PRODUCT">Product</option>
                                            <option value="TECHNICAL">Technical</option>
                                            <option value="GENERAL">General</option>
                                            <option value="OTHERS">Others</option>
                                        </select>
                                        <small *ngIf="submitted && addSupportForm.get('type').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="subject">Subject</label>
                                        <input class="form-control " id="subject" type="text" formControlName="subject">
                                        <small *ngIf="submitted && addSupportForm.get('subject').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="remarks">Remarks</label>
                                        <textarea class="form-control resize-none" id="remarks" type="text" rows="3"
                                                  formControlName="remark"></textarea>
                                        <small *ngIf="submitted && addSupportForm.get('remark').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-group">
                                        <label for="remarks">Upload Supportive Documents</label>
                                        <h6>
                                            <button class="btn btn-primary background-blue btn-sm"
                                                    (click)="fileUploadSupportDoc.click()">
                                                <i class="fa fa-cloud-upload"></i>
                                                Upload
                                            </button>
                                            <input type="file" class="display-hidden"
                                                   (change)="onFileChange($event, 'SUPPORT_DOCUMENT')"
                                                   #fileUploadSupportDoc/>
                                            <small class="text-info text-italic ml-5px mt-5px cursor-pointer"
                                                   *ngIf="supportDocData && supportDocData.id"
                                                   (click)="openExternalUrl(imageBaseUrl+supportDocData.partial_url)">View</small>
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <button type="reset" rippleEffect class="btn btn-danger" (click)="toggleSidebar()">
                                        Cancel
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="submit()" *ngIf="!data || !data['id']">Submit
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="update()" *ngIf="data && data['id']">Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </form>
        </div>
    </div>
</div>
